import React, { useState } from "react";
import styled from "styled-components";
import { ButtonS } from "../../styles/Common";
import icoCaution from "../../styles/images/ico_caution.svg";
import spinner from "../../styles/images/spinner2.gif";

export const Loading = (props) => {
  return (
    <LoadingWrapper>
      <LoadingContainer>
        <img src={spinner} alt="로딩중" />
      </LoadingContainer>
    </LoadingWrapper>
  );
};

const LoadingWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(37, 21, 98, 0.33);
  z-index: 9999999999;
`;

const LoadingContainer = styled.div`
  position: absolute;
  width: fit-content;
  height: fit-content;
  margin: auto;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: transparent;
  img {
    width: 8rem;
  }
`;
